import { PageHero } from "@/components/shared/PageHero";
import { CTASection } from "@/components/shared/CTASection";
import chuckFamily from "@/assets/chuck-family.jpg";

const About = () => {
  return (
    <>
      <main>
        <PageHero
          badge="About Us"
          title="Built on Trust"
          subtitle="Quality craftsmanship and honest service for Minnesota homeowners."
        />

        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground">
                  A Roofing Company Built on Hard Work
                </h2>
                <p className="text-xl md:text-2xl text-muted-foreground mt-2">
                  (and a Strong Dislike for Doing Things Twice)
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
                <div>
                  <img
                    src={chuckFamily}
                    alt="Chuck and his family - the heart behind Cedar Creek Construction"
                    className="rounded-3xl shadow-xl w-full"
                  />
                </div>
                <div className="space-y-6">
                  <p className="text-lg text-muted-foreground leading-relaxed">
                    I'm <strong className="text-foreground">Chuck</strong>,
                    owner of{" "}
                    <strong className="text-foreground">
                      Cedar Creek Construction
                    </strong>
                    , and a dad to five kids. Which means I've learned to show
                    up, follow through, and fix problems before they turn into
                    bigger ones. I've also learned that doing things twice is
                    usually avoidable—and always annoying.
                  </p>
                  <p className="text-lg text-muted-foreground leading-relaxed">
                    I started{" "}
                    <strong className="text-foreground">
                      Cedar Creek Construction
                    </strong>{" "}
                    because roofing doesn't need to be complicated or dramatic.
                    You need a roof that works, a contractor who doesn't
                    disappear, and a job that's done correctly the first time.
                  </p>
                </div>
              </div>

              <div className="bg-primary/5 rounded-2xl p-8 mb-12 text-center">
                <p className="text-2xl font-heading font-semibold text-foreground italic">
                  "We believe 'good enough' is how leaks start."
                </p>
              </div>

              <div className="space-y-6 mb-12">
                <p className="text-lg text-muted-foreground leading-relaxed">
                  So we keep things simple. We show up when we say we will. We
                  do the work right. We clean up when we're done. No sales
                  pressure, no mystery timelines, and no half-finished jobs that
                  somehow count as "almost done."
                </p>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  If something isn't right, we fix it. If we say we'll be there,
                  we are. Mild sarcasm may occur, but the work is always
                  serious.
                </p>
              </div>

              <div className="text-center border-t border-border pt-8">
                <p className="text-xl font-heading font-bold text-foreground mb-2">
                  Cedar Creek Construction
                </p>
                <p className="text-lg text-muted-foreground italic">
                  Doing the job right so you don't have to think about it again.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-section-alt">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-heading font-bold text-foreground mb-8">
                Why Choose Cedar Creek Construction?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="feature-card text-center">
                  <div className="text-4xl font-heading font-bold text-secondary mb-2">
                    MN
                  </div>
                  <p className="text-muted-foreground">Licensed #BC645307</p>
                </div>
                <div className="feature-card text-center">
                  <div className="text-4xl font-heading font-bold text-secondary mb-2">
                    100%
                  </div>
                  <p className="text-muted-foreground">
                    Satisfaction Guaranteed
                  </p>
                </div>
                <div className="feature-card text-center">
                  <div className="text-4xl font-heading font-bold text-secondary mb-2">
                    ★★★★★
                  </div>
                  <p className="text-muted-foreground">5-Star Reviews</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
    </>
  );
};

export default About;
